import type { TFileWithMeta } from '@components/Files/UploadProvider/types/TFileWithMeta';
import { PrismaRepositoryAttachmentDto } from 'app/API';

export function mapRepositoryAttachmentsToFiles(
  attachments: PrismaRepositoryAttachmentDto[],
): Array<Partial<TFileWithMeta> & { meta: Partial<TFileWithMeta['meta']> }> {
  const now = new Date().toISOString();
  return attachments.map((attachment) => ({
    meta: {
      id: attachment.id,
      name: attachment.fileName,
      size: Number(attachment.fileSize),
      status: 'external',
      percent: 100,
      uploadedAt: now,
      extra: {
        repositoryAttachmentId: attachment.id,
        repositoryRegistered: true,
        duration: attachment.audioDuration ?? undefined,
      },
    },
  }));
}
